import { CodeHighlightNode, CodeNode } from '@lexical/code'
import { AutoLinkNode, LinkNode } from '@lexical/link'
import { ListItemNode, ListNode } from '@lexical/list'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { ParagraphNode, TextNode } from 'lexical'
import { EmojiNode } from './node/EmojiNode'
import { ImageNode } from './node/ImageNode'
import { StyledParagraphNode } from './node/StyledParagraph'
import { editorTheme } from './theme'

export const LEXICAL_DEFAULT_CONFIG = {
  nodes: [
    ParagraphNode,
    TextNode,
    HeadingNode,
    EmojiNode,
    ImageNode,
    QuoteNode,
    CodeNode,
    CodeHighlightNode,
    ListNode,
    ListItemNode,
    LinkNode,
    AutoLinkNode,
    StyledParagraphNode,
  ],
  onError: console.error,
  theme: editorTheme,
}
